var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.currentComponent,{key:_vm.deviceClass,tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }